// =========================================================================
// actionHref — resolve a seed/engine `OemAction` to a route. Issues module,
// fork-owned (zone C).
//
// Every cross-reference in the ported seeds travels as `{ view, sub }` (see
// `shared/seed/action.ts`); `shared/oem-routes.ts` owns the view → route
// table. This is the one-line adapter the Issues scenes use so no scene calls
// `routeForView` with a literal or hand-writes a path.
//
// Transformation layer — pure.
// =========================================================================

import { routeForView } from '@/versions/v1/shared/oem-routes';
import type { OemAction } from '@/versions/v1/shared/seed/action';

/**
 * actionHref(action) → string
 * Projection rule: `routeForView` returns `null` for a view with no ported
 *   destination. Rather than silently landing on `/`, the caller gets `null`
 *   and renders the label as inert text.
 */
export function actionHref(action: OemAction): string | null {
  return routeForView(action.view, action.sub);
}
